import { parseBlogVideo } from "@/lib/blog-video";

export function MarkdownVideo({ source }: { source: string }) {
  const video = parseBlogVideo(source);
  if (!video) return null;

  if (video.kind === "youtube") {
    const params = new URLSearchParams();
    if (video.startSeconds) params.set("start", String(video.startSeconds));
    const query = params.toString();
    const embedUrl = `https://www.youtube-nocookie.com/embed/${video.videoId}${query ? `?${query}` : ""}`;

    return (
      <div className="not-prose my-8 overflow-hidden rounded-2xl border border-border bg-black shadow-[var(--shadow-soft)]">
        <div className="relative aspect-video">
          <iframe
            className="absolute inset-0 h-full w-full"
            src={embedUrl}
            title="Video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </div>
      </div>
    );
  }

  return (
    <div className="not-prose my-8 overflow-hidden rounded-2xl border border-border bg-black shadow-[var(--shadow-soft)]">
      <video
        className="aspect-video w-full"
        src={video.src}
        controls
        playsInline
        preload="metadata"
      />
    </div>
  );
}
